import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NavigationService} from '../../../../../../../../shared/services/navigation/navigation.service';
import {ZbiorUszkodzen} from '../../../../../../../../shared/store/zbior-uszkodzen/zbiorUszkodzen';
import {SlownikUszkodzen} from '../../../../../../../../shared/model/uszkodzenia/slownik-uszkodzen';
import {LokalizacjaUszkodzenia} from '../../../../../../../../shared/model/uszkodzenia/lokalizacja-uszkodzenia';

@Component({
  selector: 'app-podsumowanie-z-uszkodzeniem',
  templateUrl: './podsumowanie-z-uszkodzeniem.component.html',
  styleUrls: ['./podsumowanie-z-uszkodzeniem.component.scss']
})
export class PodsumowanieZUszkodzeniemComponent {

  language = window.navigator.language

  constructor(private navigationService: NavigationService) {
  }

  @Input()
  lokalizacja!: string

  @Input()
  zbiorUszkodzenPrzedmiotuId!: number

  @Input()
  zbiorUszkodzen!: ZbiorUszkodzen

  @Output()
  usunZbiorUszkodzenClick = new EventEmitter<{zbiorUszkodzenPrzedmiotowId: number, zbiorUszkodzenId: string}>()

  edytujZbiorUszkodzen(): void {
    if (SlownikUszkodzen.DODATKOWE_PRACE.nazwa === this.lokalizacja) {
      this.navigationService.navigateWithExtras(['/procesUszkodzen/przedmiotUbezpieczenia/dodatkowePrace'], {queryParams: {idPrzedmiotu: this.zbiorUszkodzenPrzedmiotuId, idZbioruUszkodzen: this.zbiorUszkodzen.id}})
    }
    else {
      this.navigationService.navigateWithExtras(['/procesUszkodzen/przedmiotUbezpieczenia/' + this.lokalizacja],
        {queryParams: {idPrzedmiotu: this.zbiorUszkodzenPrzedmiotuId, idZbioruUszkodzen: this.zbiorUszkodzen.id}});
    }
  }

  usunZbiorUszkodzen(event: {zbiorUszkodzenPrzedmiotowId: number, zbiorUszkodzenId: string}): void {
    this.usunZbiorUszkodzenClick.emit(event)
  }

  czyPomieszczenie(): boolean {
    return LokalizacjaUszkodzenia.pobierzPomieszczenia().includes(LokalizacjaUszkodzenia.pobierz(this.lokalizacja))
  }

  czyLokalizacjaZWymiaramiPomieszczenia(): boolean {
    const lokalizacjeZWymiarami = LokalizacjaUszkodzenia.pobierzPomieszczenia()
      .concat(LokalizacjaUszkodzenia.POMIESZCZENIE_GOSPODARCZE, LokalizacjaUszkodzenia.POMIESZCZENIE_GARAZOWE)
    return lokalizacjeZWymiarami.includes(LokalizacjaUszkodzenia.pobierz(this.lokalizacja))
  }
}
